import { render, staticRenderFns } from "./workspace-library-physical-storage-form.vue?vue&type=template&id=f8555900"
import script from "./workspace-library-physical-storage-form.vue?vue&type=script&lang=js"
export * from "./workspace-library-physical-storage-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports